module.exports = __webpack_public_path__ + "img/logo_big.07203a6f.png";